export default __webpack_public_path__ + "static/media/7.3.e4b36ced.jpg";